import script from "./DailyDroppedOrdersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyDroppedOrdersChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyDroppedOrdersChart.vue?vue&type=style&index=0&id=23475b5f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23475b5f"]])

export default __exports__